import React, { useEffect } from 'react';
import HeaderComponent from "../Header/component"
import FooterComponent from "../Footer/component"

import devopsSolution from "../../assets/img/demo/devops_solution.jpg"
import pageBannerbg from "../../assets/img/page_banner_bg.svg"


import "./styles.scss"

export default function DevOpsSolutionComponent() {
  useEffect(() => {
    window.scrollTo(0, 0)
  });

  return (
    <>
      <main id="main" className="site-main content-no-spacing devops__solution-wrapper">
        <HeaderComponent />
        <div className="content">
          <div className="clearfix">
            <section className="page__banner">
               <img className="page__banner-bg" src={pageBannerbg} alt=""/>
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="entry-banner">
                      <h1 className="entry-title">DevOps solution</h1>
                      <div className="breadcrumb-area">
                        <div className="entry-breadcrumb">
                          <li className="active">
                            <a href="#">Bubble</a>
                          </li>
                          <li className="active">
                            <a href="#">Services</a>
                          </li>
                          <li>
                            <a href="#">DevOps solution</a>
                          </li>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="post-thumb-section">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <img className="img-thumbnail img-fluid" src={devopsSolution} alt=""/>
                  </div>
                </div>
                <div className="post-thumb-info">
                  <div className="thumb-text-inner">
                    <p>DevOps has become a cornerstone of the IT department in organizations wishing to speed up software development and deliver new applications, faster. Now that the cloud is ubiquitous, this once-niche field is transforming how many businesses operate and bringing the days of clunky, cumbersome IT rollouts to an end.</p>
                    <br/>
                    <p>DevOps will continue to evolve in the coming years as companies identify new IT challenges to be solved, particularly as they look to automation to optimize or even remove processes that stand in the way of business agility.</p>
                    <p>That’s according to a new report from tech analyst firm Forrester, which says tech leaders need to prepare for “big-picture changes” as DevOps changes the face of business innovation and transformation.</p>
                  </div>                  
                </div>
              </div>
            </section>

            <section className="We__work_with-section">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="We__work_with-inner text-center">
                      <h2 className="title">We work with:</h2>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <ol className="list">
                      <li className="items">Docker</li>
                      <li className="items">CI/CD (Continuous integration (CI) and continuous delivery (CD))</li>
                      <li>DevOps Pipeline:</li>
                      <li>IaC: Infrastructure as Code</li>
                      <li>jenkins</li>
                      <li>AWS (Amazon Web Services)</li>
                      <li>Kubernetes</li>
                      <li>AZURE</li>
                      <li>Git</li>
                      <li>Github</li>
                      <li>SVN</li>
                      <li>Microservices</li>
                    </ol>
                  </div>
                </div>
              </div>
            </section>

            

          </div>
        </div>
      </main>

       
      <FooterComponent />
    </>
  )
}
